<template>
  <div class="mb-2">
    <app-filter :filters="filters" :filter-submitting="filterSubmitting" @filter="handleFilter" />
  </div>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    AppFilter
  },
  mixins: [helper],
  props: {
    values: {
      type: Object,
      required: true
    },
    filterSubmitting: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  computed: {
    filters() {
      return [
        {
          id: 'name',
          label: 'Name',
          type: 'text',
          placeholder: 'Name'
        }
      ];
    }
  },
  methods: {
    handleFilter(filters) {
      this.$emit('filter', filters);
    }
  }
};
</script>
